import { cn } from "@/lib/utils";

/** Variante de color para Input / Textarea v2 (default: slate = gris neutro). */
export type FieldVariant = "violet" | "sky" | "amber" | "emerald" | "rose" | "slate" | "subtle";

type FieldVariantStyle = {
  border: string;
  focusBorder: string;
  focusRing: string;
  label: string;
};

const FIELD_VARIANT_STYLES: Record<FieldVariant, FieldVariantStyle> = {
  violet: {
    border: "border-indigo-300/80 dark:border-indigo-800/80",
    focusBorder: "focus:border-indigo-500 dark:focus:border-indigo-400",
    focusRing: "focus:ring-indigo-500/25 dark:focus:ring-indigo-400/20",
    label: "text-indigo-600 dark:text-indigo-400",
  },
  sky: {
    border: "border-sky-300/80 dark:border-sky-800/80",
    focusBorder: "focus:border-sky-500 dark:focus:border-sky-400",
    focusRing: "focus:ring-sky-500/25 dark:focus:ring-sky-400/20",
    label: "text-sky-600 dark:text-sky-400",
  },
  amber: {
    border: "border-amber-300/80 dark:border-amber-800/80",
    focusBorder: "focus:border-amber-500 dark:focus:border-amber-400",
    focusRing: "focus:ring-amber-500/25 dark:focus:ring-amber-400/20",
    label: "text-amber-600 dark:text-amber-400",
  },
  emerald: {
    border: "border-emerald-300/80 dark:border-emerald-800/80",
    focusBorder: "focus:border-emerald-500 dark:focus:border-emerald-400",
    focusRing: "focus:ring-emerald-500/25 dark:focus:ring-emerald-400/20",
    label: "text-emerald-600 dark:text-emerald-400",
  },
  rose: {
    border: "border-rose-300/80 dark:border-rose-800/80",
    focusBorder: "focus:border-rose-500 dark:focus:border-rose-400",
    focusRing: "focus:ring-rose-500/25 dark:focus:ring-rose-400/20",
    label: "text-rose-600 dark:text-rose-400",
  },
  slate: {
    border: "border-slate-300/80 dark:border-zinc-700/80",
    focusBorder: "focus:border-slate-500 dark:focus:border-zinc-400",
    focusRing: "focus:ring-slate-500/20 dark:focus:ring-zinc-400/15",
    label: "text-slate-600 dark:text-zinc-400",
  },
  subtle: {
    border: "border-slate-200/60 dark:border-zinc-800/60",
    focusBorder: "focus:border-slate-400 dark:focus:border-zinc-500",
    focusRing: "focus:ring-slate-400/15 dark:focus:ring-zinc-400/10",
    label: "text-slate-500 dark:text-zinc-500",
  },
};

export function fieldVariantClasses(
  variant: FieldVariant = "slate",
  options?: { error?: boolean }
) {
  if (options?.error) {
    return {
      border: "border-destructive dark:border-destructive",
      focusBorder: "focus:border-destructive",
      focusRing: "focus:ring-destructive/20",
      label: "text-destructive",
    };
  }

  return FIELD_VARIANT_STYLES[variant];
}

export function mergeFieldControlClass(
  variant: FieldVariant = "slate",
  options?: { error?: boolean; className?: string }
) {
  const v = fieldVariantClasses(variant, options);
  return cn(
    v.border,
    v.focusBorder,
    v.focusRing,
    options?.className
  );
}
